export const DIFFICULTY_OPTIONS = ['Easy', 'Medium', 'Hard'];

// Keep in sync with the `source` values views.py actually sets on Recipe rows.
export const SOURCE_LABELS: Record<string, string> = {
  ai_discovered: 'AI Discovered',
  quick_meal: 'Quick Meal',
  manual: 'Manual',
  url_import: 'URL Import',
  text_import: 'Pasted Text',
};

export const sourceLabel = (source: string): string => SOURCE_LABELS[source] || source;
